import React from 'react';
import { Column, Columns } from '@codeparva/ui-components-library';
import { ContactForm } from '../components/ContactForm';
import { ContactUsPageTypes } from '../ContactUsPageTypes';
import { widescreensize } from '../../../utilities/constants';
import { StandardContactDetails } from '../components/ContactDetails';
import { useWindowDimensions } from '../../../utilities/Dimensions';

const GetTitle = ({ title }: { title: String }) => {
  return (
    <Column
      display="flex"
      justifyContent="left"
      alignItems="center"
      className="p-0"
    >
      <div className="is-flex">
        <div className="contactUsHeadingBorder"></div>
        <h3 className="pt-5">{title}</h3>
      </div>
    </Column>
  );
};

export const ContactUsDarkTheme = ({
  variant,
  contactDetails,
}: ContactUsPageTypes.IContactUsPage) => {
  const { contactUsFormHeading } = contactDetails;
  return (
    <div className="contactUsPageParent">
      {contactUsFormHeading && <GetTitle title={contactUsFormHeading} />}
      <Columns className="mt-4 standardSection is-centered liftingUp mx-0">
        <Column className="is-5 detailsContainer has-background-primary">
          <StandardContactDetails
            variant={variant}
            contactDetails={contactDetails}
          />
        </Column>
        <Column className="is-7 formContainer">
          <ContactForm {...contactDetails} />
        </Column>
      </Columns>
    </div>
  );
};

export const ContactUsLightTheme = ({
  variant,
  contactDetails,
}: ContactUsPageTypes.IContactUsPage) => {
  const { contactUsFormHeading } = contactDetails;
  const { width } = useWindowDimensions();
  return (
    <div className="contactUsPageParent has-background-secondary">
      {contactUsFormHeading && <GetTitle title={contactUsFormHeading} />}
      <Columns className="standardSection mapUnderDetailsParent is-centered pb-6 mx-0">
        <Column
          className={`${
            width <= widescreensize ? 'is-5' : 'is-4'
          }  detailsContainer mapUnderDetails`}
        >
          <StandardContactDetails
            variant={variant}
            contactDetails={contactDetails}
          />
        </Column>
        <Column
          className={`${
            width <= widescreensize ? 'is-7' : 'is-8'
          } formContainer`}
        >
          <ContactForm {...contactDetails} />
        </Column>
      </Columns>
    </div>
  );
};
